import { EventEmitter, Injectable, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { NavigationMainComponent } from '../navigation-main/navigation-main.component';
import { NavigationSidebarComponent } from './navigation-sidebar.component';

@Injectable({
  providedIn: 'root'
})
export class SidebarToggleService {

  public isMenuCollapsed: boolean = false;

  private subject = new BehaviorSubject<boolean>(this.isMenuCollapsed);

  constructor() { }

  public toggle() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.subject.next(this.isMenuCollapsed);
  }
  
  public GetValue(): Observable<boolean> {
    return this.subject.asObservable();
  }

  public get currentValue(): boolean {
    return this.isMenuCollapsed;
  }
}
